// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

interface OwnProps {
    isQtyAdjusted: boolean;
    multipleProducts: boolean;
    // XNG-Changes
    showItemsWillBeBackOrderMessage?: boolean;
    isOutOfStock?: boolean;
    addedRequiredProducts?: boolean;
}

type Props = OwnProps;

export interface ProductAddedToCartMessageStyles {
    messageWrapper?: InjectableCss;
    defaultText?: TypographyPresentationProps;
    quantityAdjustedText?: TypographyPresentationProps;
}

export const productAddedToCartMessageStyles: ProductAddedToCartMessageStyles = {
    defaultText: {
        variant: "p",
    },
    quantityAdjustedText: {
        variant: "p",
    },
};

const styles = productAddedToCartMessageStyles;

const ProductAddedToCartMessage = ({ 
    isQtyAdjusted,
    multipleProducts,
    // XNG-Changes
    showItemsWillBeBackOrderMessage = false,
    isOutOfStock = false,
    addedRequiredProducts = false,
}: Props) => {
    const defaultMessage = multipleProducts
        ? siteMessage("Cart_AllProductsAddedToCart")
        : siteMessage("Cart_ProductAddedToCart");

    if (!isQtyAdjusted && !showItemsWillBeBackOrderMessage && !isOutOfStock) {
        return <Typography {...styles.defaultText}>{defaultMessage}</Typography>;
    }
    
    return (
        <StyledWrapper {...styles.messageWrapper}>
            <Typography {...styles.defaultText}>{defaultMessage}</Typography>
            {isQtyAdjusted &&
                <Typography {...styles.quantityAdjustedText}>{siteMessage("Cart_QuantityAdjusted")}</Typography>
            }
            {isOutOfStock &&
                <Typography {...styles.quantityAdjustedText}>{siteMessage("Str_Cart_AllItemsWillBeBackOrdered")}</Typography>
            }
            {showItemsWillBeBackOrderMessage && !isOutOfStock &&
                <Typography {...styles.quantityAdjustedText}>{siteMessage("Str_Cart_SomeItemsWillBeBackOrdered")}</Typography>
            }
            {addedRequiredProducts &&
                <Typography {...styles.quantityAdjustedText}>{siteMessage("Str_Cart_SomeOtherRequiredProductsAreAddedToCart")}</Typography>
            }
        </StyledWrapper>
    );
};

export default ProductAddedToCartMessage;
